import { combineReducers } from 'redux';
import loadingReducer from './loadingReducer';
import loginReducer from './loginReducer';
import userReducer from './userReducer';
import storageReducer from './storageReducer';

export default combineReducers({
   loading: loadingReducer,
   login: loginReducer,
   user: userReducer,
   storage: storageReducer
});